import * as actionTypes from './types';

function _setSearchResults(state, action) {
    const {
        meta: {
            searchId,
            batchId,
            override,
        },
        payload: {
            tripIds,
            tripMetadata = {},
        },
    } = action;
    const {
        scores = {},
        stats = {},
    } = tripMetadata;

    if (state[searchId] && !override) {
        return state;
    }

    const psearchSet = state[searchId] || {};
    const exisitingTripIds = psearchSet.tripIds || [];
    const exisitingTripMetaData = psearchSet.tripMetadata || {};
    const existingTripScores = psearchSet.tripScores || {};

    return {
        ...state,
        [searchId]: {
            tripIds: [...new Set([...exisitingTripIds, ...tripIds])],
            tripMetadata: {
                ...exisitingTripMetaData,
                ...stats,
            },
            tripScores: {
                ...existingTripScores,
                ...scores,
            },
            batchId,
        },
    };
}

function _clearSearchResults(state, action) {
    const {
        meta: searchId,
    } = action;

    const {
        [searchId]: _searchIdToRemove,
        ...newState
    } = state;

    return newState;
}

const reducerFunctions = {
    [actionTypes.SET_SEARCH_RESULTS]: _setSearchResults,
    [actionTypes.CLEAR_SEARCH_RESULTS]: _clearSearchResults,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
